/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScannerMappingDto
 */
export interface ScannerMappingDto {
    /**
     * 
     * @type {string}
     * @memberof ScannerMappingDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ScannerMappingDto
     */
    scannerType?: string;
    /**
     * 
     * @type {string}
     * @memberof ScannerMappingDto
     */
    scannerId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ScannerMappingDto
     */
    cveIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ScannerMappingDto
     */
    syncedAt?: string;
}

/**
 * Check if a given object implements the ScannerMappingDto interface.
 */
export function instanceOfScannerMappingDto(value: object): value is ScannerMappingDto {
    return true;
}

export function ScannerMappingDtoFromJSON(json: any): ScannerMappingDto {
    return ScannerMappingDtoFromJSONTyped(json, false);
}

export function ScannerMappingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScannerMappingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'scannerType': json['scannerType'] == null ? undefined : json['scannerType'],
        'scannerId': json['scannerId'] == null ? undefined : json['scannerId'],
        'cveIds': json['cveIds'] == null ? undefined : json['cveIds'],
        'syncedAt': json['syncedAt'] == null ? undefined : json['syncedAt'],
    };
}

export function ScannerMappingDtoToJSON(json: any): ScannerMappingDto {
    return ScannerMappingDtoToJSONTyped(json, false);
}

export function ScannerMappingDtoToJSONTyped(value?: ScannerMappingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'scannerType': value['scannerType'],
        'scannerId': value['scannerId'],
        'cveIds': value['cveIds'],
        'syncedAt': value['syncedAt'],
    };
}

